import { types } from 'mobx-state-tree';

import { LicenceTypeValuesOntario } from '../definitions/LicenseTypeValues';
import LicenceBase from './LicenceBase';


const LicenceON = LicenceBase
    .named('LicenceON')
    .props({
        // Note: firstLicenceType is also declared on LicenceAB with
        // the same key, but different emum values.  Mobx will accept 
        // both LicenseTypeValuesOntario or LicenseTypeValuesAlberta
        // as valid values to resolve the union on ./Drivers.licencing
        firstLicenceType: types.enumeration(
            Object.values(LicenceTypeValuesOntario),
        ),
    
        hasG2Licence: types.maybeNull(types.boolean),
        g2LicenceAge: types.maybeNull(types.number),
        
        hasGLicence: types.maybeNull(types.boolean),
        gLicenceAge: types.maybeNull(types.number),
    });

export default LicenceON;
